import { RouteProps } from 'react-router';

// import PageHome from 'pages/Home';
import PageSearch from 'pages/Search';
import PageBrands from 'pages/Brands';
import PageCategories from 'pages/Categories';
import PageProductId from 'pages/Products/ProductId';
import PageHelp from 'pages/Help';

export const ROUTES: RouteProps[] = [
  // {
  //   element: <PageHome />,
  //   path: '/',
  // },
  {
    element: <PageSearch />,
    path: '/',
  },
  {
    element: <PageSearch />,
    path: '/search',
  },
  {
    element: <PageBrands />,
    path: '/brands',
  },
  {
    element: <PageCategories />,
    path: '/categories',
  },
  {
    element: <PageProductId />,
    path: '/products/:productId',
  },
  {
    element: <PageHelp />,
    path: '/help',
  },
];
